import { WSElementColorsType } from "@wingspanhq/fe-component-library";
import { PayrollRunStatus } from "@wingspanhq/wingspan-api-sdk";

/** Colour of the secondary status line, paired with `selectorPayrollRunStatusPill`. */
const PAYROLL_RUN_STATUS_COLOR: Record<PayrollRunStatus, WSElementColorsType> =
  {
    [PayrollRunStatus.DRAFT]: "blue500",
    [PayrollRunStatus.PENDING_APPROVALS]: "amber400",
    [PayrollRunStatus.FINALIZED]: "amber400",
    [PayrollRunStatus.PROCESSING]: "amber400",
    [PayrollRunStatus.PAID]: "green400",
    [PayrollRunStatus.PARTIALLY_PAID]: "amber400",
    [PayrollRunStatus.CANCELLED]: "gray500",
    [PayrollRunStatus.FAILED]: "red400"
  };

export const selectorPayrollRunStatusColor = (
  status?: PayrollRunStatus
): WSElementColorsType =>
  PAYROLL_RUN_STATUS_COLOR[status ?? PayrollRunStatus.PENDING_APPROVALS];
